import Vue from "vue";
import moment from "moment-timezone";

export default () => {
  Vue.filter("dateString", (dateTime) => {
    if (!dateTime) return "None";
    return moment.tz(dateTime, "UTC").tz("America/New_York").format("MM/DD/YYYY");
  });
  Vue.filter("dateStringNullIsNA", (dateTime) => {
    if (!dateTime) return "N/A";
    return moment.tz(dateTime, "UTC").tz("America/New_York").format("MM/DD/YYYY");
  });

  Vue.filter("dateTimeString", (dateTime) => {
    if (!dateTime) return dateTime;
    return moment.tz(dateTime, "UTC").tz("America/New_York").format("MM/DD/YYYY, hh:mm A");
  });

  Vue.filter("yearFromDateTimeString", (dateTime) => {
    if (!dateTime) return dateTime;
    return moment.tz(dateTime, "UTC").tz("America/New_York").format("YYYY");
  });

  Vue.filter("contactAddress", (contact) => {
    if (!contact || !contact.address) return "None";
    return `${contact.address}<br>${contact.city}, ${contact.state} ${contact.postalCode}`;
  });

  Vue.filter("contactName", (contact) => {
    if (!contact) return "";
    return contact.name ? contact.name : contact.fullName;
  });

  Vue.filter("contactNameOrDefault", (contact) => {
    if (!contact || (!contact.fullName && !contact.name)) return "None";
    return contact.name ? contact.name : contact.fullName;
  });

  Vue.filter("moneyFormat", (money) => {
    if (money === null || money === undefined) return money;
    return money.toLocaleString("en-US", { style: "currency", currency: "USD" });
  });

  Vue.filter("numberFormat", (value) => {
    if (value === null || Number.isNaN(Number(value))) return "None";
    return Number(value).toLocaleString("en-US");
  });

  Vue.filter("numberFormatNullIsNA", (value) => {
    if (value === null || Number.isNaN(Number(value))) return "N/A";
    return Number(value).toLocaleString("en-US");
  });

  Vue.filter("acresFormat", (value) => {
    if (value === null || Number.isNaN(Number(value))) return "None";
    return Number(value).toLocaleString("en-US", { maximumFractionDigits: 4 });
  });

  Vue.filter("acresFormatNullIsNA", (value) => {
    if (value === null || Number.isNaN(Number(value))) return "N/A";
    return Number(value).toLocaleString("en-US", { maximumFractionDigits: 4 });
  });
  Vue.filter("formatBooleanAsYesNo", (value) => (value ? "Yes" : "No"));
};
